import { ApiParameter, del, get, post, request } from "@insite/client-framework/Services/ApiService";
import uniqueId from "@insite/mobius/utilities/uniqueId";

const updatePermissionUrl = "/api/v2/userRoles/UpsertFeatureRolePermissions";
const fetchPageWidgetUrl = "/api/v2/userRoles/FetchPageWidgetData";
const getFeatureRolePermissionCollectionUrl = "/api/v2/userRoles/GetFeatureRolePermissionCollection";
const getFeatureRolePermissionDetailUrl = "/api/v2/userRoles/GetFeatureRolePermissionDetail";
const deleteFeatureRolePermissionsUrl = "/api/v2/userRoles/DeleteFeatureRolePermissions";
const importFeatureRolePermissionsDetailsUrl = "/api/v2/userRoles/ImportFeatureRolePermissionsDetails";
export const exportFeatureRolePermissionsDetailsUrl = "/api/v2/userRoles/ExportFeatureRolePermissionsDetails";
export const getPageDetailsUrl = "/api/v2/userRoles/FetchPageData";
export const getWidgetDetailsUrl = "/api/v2/userRoles/FetchWidgetData";
const getOOTBPageDetailsUrl = "/api/v2/userRoles/FetchOotbPagesData";
const getOOTBWidgetDetailsUrl = "/api/v2/userRoles/FetchOotbWidgetsData";

export interface SecurityRolesParams extends ApiParameter {
    roleName?: string;
    customerNumber?: string;
    featureName?: string;
    featureSubPage?: string;
    page?: number;
    pageSize?: number;
    defaultPageSize?: number;
    sort?: string;
    properties?: any;
    isValid?: boolean;
    validationMessage?: string;
    guid?: string;
    ootbPage?: string;
    ootbWidget?: string;
}

export interface RolesCollection {
    uri: string;
    featureRolePermissionsProperties: FeatureRolePermissionsProperty[];
    pagination: Pagination;
    properties: Properties;
}

export interface FeatureRolePermissionsProperty {
    isEdit: boolean;
    roleName: string;
    customerNumber: string;
    featureDetails?: FeatureDetail[];
}

export interface FeatureDetail {
    featureName: string;
    featureSubPage: string;
    featureType?: string;
    isOotbFeature?: boolean;
}

export interface Pagination {
    currentPage: number;
    page: number;
    pageSize: number;
    defaultPageSize: number;
    totalItemCount: number;
    numberOfPages: number;
    pageSizeOptions: any[];
    sortOptions: any;
    sortType: any;
    nextPageUri: any;
    prevPageUri: any;
}

export interface Properties {}

export interface PageWidgetCollectionParameters extends ApiParameter {
    guid?: string;
}

export interface PageWidgetCollection {
    customPageDetails: PageDetail[];
    oobPageDetails: PageDetail[];
    customWidgetDetails: WidgetDetail[];
    oobWidgetDetails: WidgetDetail[];
}

export interface PageDetail {
    id: string;
    customProperties: any[];
    featureName: string;
    featureSubPage: string;
    featureType: string;
    createdOn: string;
    createdBy: string;
    modifiedOn: string;
    modifiedBy: string;
    isOotbFeature: boolean;
}

export interface WidgetDetail {
    id: string;
    customProperties: any[];
    featureName: string;
    featureSubPage: string;
    featureType: string;
    createdOn: string;
    createdBy: string;
    modifiedOn: string;
    modifiedBy: string;
}

export interface GetWidgetDetailsParameter extends ApiParameter {
    pageName: string;
}

export const getRolesCollection = async (parameters: SecurityRolesParams) => {
    const response = await get<RolesCollection>(getFeatureRolePermissionCollectionUrl, {
        ...parameters,
        guid: uniqueId(),
    } as SecurityRolesParams);
    return response;
};

export const getPagesWidget = async () => {
    const response = await get<PageWidgetCollection>(fetchPageWidgetUrl);
    return response;
};

export const getPageDetailsHn = async () => {
    const response = await get<PageWidgetCollection>(getPageDetailsUrl);
    return response;
};

export const getPagesWidgetHn = async (parameter: GetWidgetDetailsParameter) => {
    const response = await get<PageWidgetCollection>(getWidgetDetailsUrl, parameter);
    return response;
};
export const getOOTBPageDetailsHn = async () => {
    const response = await get<PageWidgetCollection>(getOOTBPageDetailsUrl);
    return response;
};

export const getOOTBWidgetDetailsHn = async (parameter: GetWidgetDetailsParameter) => {
    const response = await get<PageWidgetCollection>(getOOTBWidgetDetailsUrl, parameter);
    return response;
};

export const deleteRole = (id: string) => {
    return del(`${deleteFeatureRolePermissionsUrl}?roleName=${id}`);
};

export const importRolesApi = async (parameters: any) => {
    const formData = new FormData();
    formData.append("File", parameters.file);
    const response = await request<any>(importFeatureRolePermissionsDetailsUrl, "POST", {}, formData);
    return response;
};

export const updateRolePermissions = async (parameters: FeatureRolePermissionsProperty) => {
    const response = await post<FeatureRolePermissionsProperty>(updatePermissionUrl, parameters);
    return response;
};

export const getSecurityRoleByRoleName = async (roleName: string) => {
    const response = await get<FeatureRolePermissionsProperty>(
        `${getFeatureRolePermissionDetailUrl}?roleName=${roleName}`,
    );
    return response;
};
